import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { Zap } from 'lucide-react';
import { whatsappAPI } from './whatsappAPI';

/* Respostas rápidas (tela Templates) dentro do campo de mensagem: "/" no começo abre a lista,
 * setas escolhem, Enter insere. Também abre pelo botão de raio. */

let cache = null;
const norm = (s = '') => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export function useRespostas(aberto) {
  const [lista, setLista] = useState(cache || []);
  useEffect(() => {
    if (!aberto) return;
    whatsappAPI.templatesList().then(r => { cache = r.data || []; setLista(cache); }).catch(() => {});
  }, [aberto]);
  return lista;
}

export function filtrarRespostas(lista, filtro) {
  const f = norm(filtro.trim());
  return (f ? lista.filter(t => norm(t.titulo).includes(f) || norm(t.conteudo).includes(f)) : lista).slice(0, 8);
}

export default function RespostasRapidas({ itens, ativo, onEscolher, filtro }) {
  const vazio = !itens.length;
  const destaque = useMemo(() => filtro.trim(), [filtro]);
  return (
    <div className="absolute bottom-full left-0 right-0 mb-2 rounded-xl border bg-white dark:bg-slate-900 shadow-xl overflow-hidden z-20" data-testid="wa-respostas">
      <div className="px-3 py-2 border-b text-xs text-slate-500 flex items-center gap-1.5">
        <Zap className="w-3.5 h-3.5 text-amber-500" /> Respostas rápidas{destaque ? <> com “{destaque}”</> : null}
        <span className="ml-auto">↑↓ escolher, Enter inserir, Esc fechar</span>
      </div>
      {vazio ? (
        <p className="px-3 py-3 text-sm text-slate-500">
          Nenhuma resposta{destaque ? ' encontrada' : ' cadastrada'}. <Link to="/whatsapp/templates" className="underline">Cadastrar respostas</Link>
        </p>
      ) : (
        <ul className="max-h-64 overflow-y-auto py-1">
          {itens.map((t, i) => (
            <li key={t.id}>
              <button type="button" onMouseDown={e => { e.preventDefault(); onEscolher(t); }} data-testid={`wa-resposta-${t.id}`}
                className={`w-full text-left px-3 py-2 ${i === ativo ? 'bg-emerald-50 dark:bg-emerald-900/30' : 'hover:bg-slate-50 dark:hover:bg-slate-800'}`}>
                <span className="text-sm font-medium block">{t.titulo}</span>
                <span className="text-xs text-slate-500 line-clamp-1">{t.conteudo}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
